import {
  Input,
  InputPartialProps,
} from '@/shared/components/ui/input/input.component';
import { FC } from 'react';

export const InputAuthzToken: FC<InputPartialProps> = ({
  id = 'input-authz-token',
  label = 'Token de autorização',
  ...rest
}) => <Input id={id} label={label} {...rest} />;

export const InputPassword: FC<InputPartialProps> = ({
  id = 'input-password',
  label = 'Senha',
  type = 'password',
  ...rest
}) => <Input id={id} label={label} type={type} {...rest} />;

export const InputConfirmPassword: FC<InputPartialProps> = ({
  id = 'input-confirm-password',
  label = 'Confirmar senha',
  type = 'password',
  ...rest
}) => <Input id={id} label={label} type={type} {...rest} />;
